import React from "react";

/**
 * Полный артикул с подсветкой невидимых символов (§4.6, G6).
 * Менеджеры случайно добавляют табы/двойные/крайние пробелы — из-за этого
 * остатки из 1С не матчатся. Здесь делаем их видимыми и предупреждаем.
 */

export const hasSuspiciousWhitespace = (article: string): boolean => {
  if (!article) return false;
  if (article !== article.trim()) return true; // крайние пробелы
  if (/\t/.test(article)) return true; // табуляция
  if (/\s{2,}/.test(article)) return true; // двойные пробелы
  if (/[\u00a0\u200b\u202f]/.test(article)) return true; // неразрывные/нулевой пробел
  return false;
};

const renderWithMarkers = (article: string): React.ReactNode[] => {
  const nodes: React.ReactNode[] = [];
  for (let i = 0; i < article.length; i++) {
    const ch = article[i];
    if (ch === "\t") {
      nodes.push(
        <span key={i} style={markerStyle} title="Табуляция">
          ⇥
        </span>
      );
    } else if (ch === " ") {
      nodes.push(
        <span key={i} style={spaceStyle} title="Пробел">
          ␣
        </span>
      );
    } else if (/[\u00a0\u200b\u202f]/.test(ch)) {
      nodes.push(
        <span key={i} style={markerStyle} title="Спецпробел (неразрывный/нулевой)">
          ⍽
        </span>
      );
    } else {
      nodes.push(<React.Fragment key={i}>{ch}</React.Fragment>);
    }
  }
  return nodes;
};

const markerStyle: React.CSSProperties = {
  background: "#ffe0e0",
  color: "#c0392b",
  borderRadius: 2,
  padding: "0 1px",
  fontWeight: 700,
};
const spaceStyle: React.CSSProperties = {
  background: "#fff3cd",
  color: "#8a6d3b",
  borderRadius: 2,
};

const ArticleCell = (props: { article: string; name?: string }) => {
  const suspicious = hasSuspiciousWhitespace(props.article);
  return (
    <span>
      <code style={{ fontSize: 13 }}>
        {suspicious ? renderWithMarkers(props.article) : props.article}
      </code>
      {props.name ? ` ${props.name}` : ""}
      {suspicious && (
        <span
          title="В артикуле есть лишние пробелы/табы. Из-за этого остатки из 1С могут не приходить. Исправьте артикул, чтобы он точно совпадал с выгрузкой 1С."
          style={{
            marginLeft: 6,
            fontSize: 11,
            color: "#c0392b",
            border: "1px solid #c0392b",
            borderRadius: 4,
            padding: "0 4px",
            cursor: "help",
          }}
        >
          ⚠ лишние символы
        </span>
      )}
    </span>
  );
};

export default ArticleCell;
